function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2408",
  "data-name": "Path 2408",
  d: "M8.266,1.083l-6.25,6.25A4.78,4.78,0,0,0,.516,10.9a4.913,4.913,0,0,0,1.5,3.6A4.913,4.913,0,0,0,5.62,16a4.914,4.914,0,0,0,3.6-1.5l4.167-4.167-.959-.917L8.266,13.583A3.713,3.713,0,0,1,5.6,14.667a3.607,3.607,0,0,1-2.646-1.1,3.631,3.631,0,0,1-1.1-2.667A3.533,3.533,0,0,1,2.974,8.25L9.224,2a2.263,2.263,0,0,1,3.208,0A2.189,2.189,0,0,1,13.1,3.6a2.329,2.329,0,0,1-.667,1.646L6.183,11.5a.883.883,0,0,1-.583.208.783.783,0,0,1-.792-.792.8.8,0,0,1,.25-.583l5.708-5.75-.958-.917L4.1,9.417A1.937,1.937,0,0,0,3.474,10.9,2.134,2.134,0,0,0,5.62,13.042a2.07,2.07,0,0,0,1.521-.625l6.25-6.25a3.46,3.46,0,0,0,1.041-2.542A3.492,3.492,0,0,0,13.37,1.063,3.491,3.491,0,0,0,10.808,0,3.391,3.391,0,0,0,8.266,1.083Z",
  transform: "translate(-0.516)",
  fill: "#afafaf",
  fillRule: "evenodd"
});

var SvgAttachmentIcon = function SvgAttachmentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13.917,
    height: 16,
    viewBox: "0 0 13.917 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttachmentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attachment-icon.6a0afc15.svg";
export { ForwardRef as ReactComponent };